import { Badge, FormControl, FormLabel, Switch, useCustomToast, VStack } from '@elkaso-app/web-design';
import { useToggleMasterCuisineActivationApi } from 'apis/crm-master-cuisines';
import React, { useCallback } from 'react';

export interface IStatusCell {
  isActive: boolean;
  cuisineId: number;
}

export const StatusCell: React.FC<IStatusCell> = ({ isActive, cuisineId }) => {
  const toast = useCustomToast();

  const { mutate: toggleActivation, isLoading: isToggling } = useToggleMasterCuisineActivationApi({
    onSuccess: (_, variables) => {
      const newStatus = variables.isActive ? 'activated' : 'deactivated';
      toast({
        title: 'Status Updated!',
        description: `Master cuisine has been ${newStatus} successfully.`,
        status: 'success',
        duration: 4000,
        isClosable: true,
      });
    },
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.message || 'Failed to update status. Please try again.';
      toast({
        title: 'Status Update Failed',
        description: errorMessage,
        status: 'error',
        duration: 6000,
        isClosable: true,
      });
    },
  });

  const handleToggleActivation = useCallback(() => {
    toggleActivation({
      id: cuisineId,
      isActive: !isActive,
    });
  }, [toggleActivation, cuisineId, isActive]);

  return (
    <VStack align='start' spacing={3}>
      <Badge colorScheme={isActive ? 'green' : 'gray'} variant='subtle' size='sm' borderRadius='md'>
        {isActive ? 'Active' : 'Inactive'}
      </Badge>

      <FormControl display='flex' alignItems='center' gap={2}>
        <Switch
          id={`activation-switch-${cuisineId}`}
          isChecked={isActive}
          onChange={handleToggleActivation}
          isDisabled={isToggling}
          size='sm'
          colorScheme='green'
        />
        <FormLabel htmlFor={`activation-switch-${cuisineId}`} mb='0' fontSize='xs' color='gray.600' fontWeight='normal'>
          {isActive ? 'Active' : 'Activate'}
        </FormLabel>
      </FormControl>
    </VStack>
  );
};
